export default "/assets/webpack-assets/GT-Walsheim-Pro-Light.ac5d364c7835cf4dabdb9df4b1267201.ttf";